import { useSelector } from 'react-redux';
import { Button, Container, Modal, Spacer, Text } from '@vinted/web-ui';
import useTranslate from 'hooks/useTranslate';
import { deleteBusinessRegistration } from 'data/api';
import { reloadPage } from 'libs/utils/window';
import * as selectors from 'state/session/selectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const CancelRegistrationModal = _ref => {
  let {
    isOpen,
    onClose
  } = _ref;
  const translate = useTranslate('business.account.cancel_registration_modal');
  const businessAccountId = useSelector(selectors.getBusinessAccountId);

  async function handleCancelRegistrationClick() {
    if (!businessAccountId) return;
    await deleteBusinessRegistration(businessAccountId);
    reloadPage();
  }

  return /*#__PURE__*/_jsx(Modal, {
    show: isOpen,
    children: /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsx(Text, {
        text: translate('title'),
        type: Text.Type.Heading,
        alignment: Text.Alignment.Center,
        width: Text.Width.Parent
      }), /*#__PURE__*/_jsx(Spacer, {}), /*#__PURE__*/_jsx(Text, {
        text: translate('body')
      }), /*#__PURE__*/_jsx(Spacer, {
        size: Spacer.Size.XLarge
      }), /*#__PURE__*/_jsx(Button, {
        text: translate('actions.cancel'),
        onClick: handleCancelRegistrationClick,
        styling: Button.Styling.Filled
      }), /*#__PURE__*/_jsx(Spacer, {
        size: Spacer.Size.Large
      }), /*#__PURE__*/_jsx(Button, {
        text: translate('actions.close'),
        onClick: onClose,
        styling: Button.Styling.Flat
      })]
    })
  });
};

export default CancelRegistrationModal;